import React, {Component} from 'react';
import {Modal, Table} from 'react-bootstrap';
import {translate} from 'react-i18next';
import swal from 'sweetalert';
import FlatButton from 'material-ui/FlatButton';

var Config = require('../../../../config');

class ModalReserved extends Component{
	constructor(props){
		super(props);

		this.handleShow = this.handleShow.bind(this);
		this.handleClose = this.handleClose.bind(this);
		this.changeCheck = this.changeCheck.bind(this);
		this.onSave = this.onSave.bind(this);

		this.state = {
			show: false,
			reserved:[]
		}
	}

	componentDidMount(){
		this.props.onRef(this);
	}

	componentWillUnmount(){
		this.props.onRef(null);
	}

	handleShow(list){
		this.setState({show:true, reserved:list});
	}

	handleClose(){
		this.setState({show:false});
	}

	changeCheck(e){
		var index = parseInt(e.target.id.split('_')[1]);
		var id = e.target.id.split('_')[2];
		var tipo = e.target.id.split('_')[0];
		var check = e.target.checked;

		this.state.reserved.map((res, i)=>{
			if(tipo === 'patient'){
				if(index === i){
					if(check){
						document.getElementById('delete_'+i+'_'+res.unit_id).checked = false;
					}
				}
			}else{
				res.reserved.map((r, j)=>{
					if(index === i){
						if(check){
							document.getElementById('patient_'+j+'_'+r.unit_reserved_id).checked = false;
						}
					}
				})
			}

		})

	}

	onSave(e){
		var obj = [];
		var valid = true;
		this.state.reserved.map((res, i)=>{
			var result = {
				reserve_ids:[]
			}

			result.unit_id = res.unit_id;
			if(document.getElementById('delete_'+i+'_'+res.unit_id).checked){
				result.delete_reserve = true;
			}else{
				result.delete_reserve = false;
			}

			res.reserved.map((r, j)=>{
				if(document.getElementById('patient_'+j+'_'+r.unit_reserved_id)){
					if(document.getElementById('patient_'+j+'_'+r.unit_reserved_id).checked){
						result.reserve_ids.push(r.unit_reserved_id);
					}
				}
					
				
			})
			
			if(result.delete_reserve || result.reserve_ids.length > 0){
				obj.push(result);	
			}
			
		})

		if(obj.length === 0){
			swal('Error', 'Debe seleccionar por lo menos una opcioón', 'error');
		}else{
			this.props.getReserved(obj);
			this.handleClose();
		}

	}

	render(){
		const {t} = this.props;
		return (
			<Modal show={this.state.show} onHide={this.handleClose}>
		       	<Modal.Header closeButton>
		        	<h1 style={{color:'orange', textAlign:'center'}}>Alerta!, Unidades Reservadas</h1>
		        </Modal.Header>
		        <Modal.Body >
		        	<div className="row">
		        		<div className="col-xs-12">
		        			<Table>
		        				<thead>
		        					<tr>
			        					<th>Retirar Reserva</th>
			        					<th>Asociar a paciente</th>
		        					</tr>
		        				</thead>
			        			<tbody>
			        				{this.state.reserved.map((res, i)=>(
			        					<tr key={i}>
			        						<td>
			        							<input type="checkbox" id={"delete_"+i+'_'+res.unit_id} onChange={this.changeCheck}
			        								style={{marginRight:'8px'}} />
			        							{res.unit_number+' '+res.component+' '+res.component_number}
			        						</td>
			        						<td>
			        							{res.reserved.map((r, j)=>(
			        								<div key={j}>
			        									<input type="checkbox" id={"patient_"+j+'_'+r.unit_reserved_id} onChange={this.changeCheck} />
			        									<span style={{marginLeft:'8px'}}>{r.patient}</span>
			        								</div>
			        							))}
			        						</td>
			        					</tr>
			        				))}
			        			</tbody>
							</Table>			        		
		        		</div>
		        	</div>
		        </Modal.Body>
		        <Modal.Footer>
		        	
		        	<FlatButton primary={true} label={t('content.generics.buttons.save')} onClick={this.onSave} />
		        	<FlatButton primary={true} label={t('content.generics.buttons.reset')}  onClick={this.handleClose}/>
		        </Modal.Footer>
	      	</Modal>
		)
	}
}

export default translate('translations')(ModalReserved)